import services from "../services";

export const synchronizationActions = {
  runSynchronization,
};

function runSynchronization(props) {
  return services.synchronizationService.runSynchronization(props);
}
